// extracted by mini-css-extract-plugin
export default {"container":"CaseTitle_container__cdJpo","name":"CaseTitle_name__f0QtP","case":"CaseTitle_case__Os3wT"};